<template>
  <div>
    <a @click="open">
      <IconEdit/>
    </a>
    <form-modal
      type="recordLabelEdit"
      title="Edit Record Label"
      :model="recordLabel"
      :isModal="isModal"
      :canDelete="$can.includes('delete-record-labels')"
      v-on:clear-modal="clearModal"
      v-on:save-record="save"
      v-on:delete-record="destroy"
    ></form-modal>
  </div>
</template>

<script>

import { RECORD_LABEL_UPDATE, RECORD_LABEL_DELETE } from '@/store/actions'
import { IconEdit } from '@/Icons/IconBase'

export default {
  name: 'RecordLabelEditButton',
  props: {
    openOnSave: Boolean,
    recordLabel: Object
  },
  components: {
    IconEdit
  },

  data() {
    return {
      isModal: false
    }
  },

  methods: {
    open() {
      this.isModal = true
    },

    save(input) {
      let data = Object.assign(input, {
        contact_id: null
      })

      if (input.contact) {
        data = Object.assign(input, {
          contact_id: input.contact.id
        })
      }

      let self = this
      this.$store.dispatch(RECORD_LABEL_UPDATE, {
        id: this.recordLabel.id,
        data: data
      }).then(function (resp) {
        self.clearModal()
      }, function (err) {
        alert(err)
      })
    },

    destroy(recordLabel) {
      let self = this
      this.$store.dispatch(RECORD_LABEL_DELETE, recordLabel.id)
        .then(function () {
          self.$router.push({ name: 'record-labels.index' })
        }, function (err) {
          alert(err)
        })
      this.clearModal()
    },

    clearModal() {
      this.isModal = false
    }
  }
}
</script>
